import React from "react";
import {
  Button,
  CircularProgress,
  Divider,
  Grid,
  Typography,
} from "@material-ui/core";
import { PhotoProvider, PhotoConsumer } from "react-photo-view";
import { NotificationManager } from "react-notifications";
import IdImageView from "./image-view";

import { IdVerificationDomain } from "../domain";

import RotateLeftIcon from "@material-ui/icons/RotateLeft";
import RotateRightIcon from "@material-ui/icons/RotateRight";

import "../style.css";

const SubmittedDocumentsView = ({ idRequest = {}, userProfile = {} }) => {
  const [images, setImages] = React.useState([]);

  React.useEffect(() => {
    const imageIds = [idRequest?.nicImageId, idRequest?.nicImage2Id];
    const filteredImageIds = imageIds.filter(Boolean);

    try {
      IdVerificationDomain.getIdVerificationRequestImages({
        requestId: idRequest?.id,
        imageIds: filteredImageIds,
        setImages,
      });
    } catch (error) {
      NotificationManager.error("Unable to get images");
      console.log(error);
    }
  }, []);

  return (
    <Grid
      item
      container
      xs
      direction="column"
      wrap="nowrap"
      className="id-submitted-duments-view gap-y-16"
    >
      <Typography className="font-weight-600">
        Submitted Documents
        <Divider />
      </Typography>

      <Grid
        item
        container
        wrap="nowrap"
        direction="column"
        className="scrollable-container gap-y-32"
      >
        {images.map((element) => (
          <IdImageView
            id={element?.imageId}
            imageSrc={element?.imageUrl}
            label={element?.label}
          />
        ))}
      </Grid>
    </Grid>
  );
};

export default SubmittedDocumentsView;
